import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SiShopware } from 'react-icons/si';
import { MdOutlineCancel } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../contexts/ContextProvider';

const Sidebar = (parms) => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();

  const profile = parms.profile

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const activeLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg  text-white  text-md m-2';
  const normalLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2';

  const links = [
    {
      title: "پیشخوان",
      links: [
        {
          name: "پیشخوان",
          link: "",
        },
      ],
    },
  
    ((profile.permissions?.includes(2) || profile.permissions?.includes(0)) && {
      title: "فرم ها",
      links: [
        {
          name: "میزبان",
          link: "mizban",
        },
        {
          name: "خادمی",
          link: "khademi",
        },
        {
          name: "پای کار حسین",
          link: "paye-kare-hossein",
        },
        {
          name: "باشگاه اربعینی",
          link: "bashgah",
        },
      ],
    }),
    ((profile.permissions?.includes(1) || profile.permissions?.includes(0)) && {
      title: "محتوا",
      links: [
        {
          name: "ایجاد محتوا",
          link: "create-post",
        },
        {
          name: "فهرست محتوا ها",
          link: "posts",
        },
      ],
    }),
    ((profile.permissions?.includes(6) || profile.permissions?.includes(0)) && {
      title: "امانت",
      links: [
        {
          name: "ایجاد آیتم امانت",
          link: "create-amanat",
        },
        {
          name: "فهرست امانات",
          link: "amanat-list",
        },
      ],
    }),
    ((profile.permissions?.includes(8) || profile.permissions?.includes(0)) && {
      title: "مرکز تماس",
      links: [
        {
          name: "ساخت گزارش تماس",
          link: "create-call"
        },
        {
          name: "گزارشات تماس",
          link: "call-reports"
        },
        {
          name: "مدیریت دسته بندی ها",
          link: "categoris-management"
        }
      ]
    }),
    ((profile.permissions?.includes(5) || profile.permissions?.includes(0)) && {
      title: "مدیریت کاربران",
      links: [
        {
          name: "مدیریت دسترسی کاربران",
          link: "users-management"
        }
      ]
    })
  ];

  return (
    <div className="ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu && (
        <>
          <div className="flex justify-between items-center">
            <Link to="/" onClick={handleCloseSideBar} className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-slate-900 mr-2">
              <span>کفیل</span>
            </Link>
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          <div className="mt-10 ">
            {links.map((item) => (
              item && <div key={item.title}>
                <p className="text-gray-400 dark:text-gray-400 m-3 mt-4 uppercase">
                  {item.title}
                </p>
                {item.links.map((link) => (
                  <NavLink
                    to={`/${link.link}`}
                    key={link.name}
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : '',
                    })}
                    className={({ isActive }) => (isActive ? activeLink : normalLink)}
                  >
                    <span className="capitalize mr-3">{link.name}</span>
                  </NavLink>
                ))}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
